import flatMap from "lodash/flatMap";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import keyBy from "lodash/keyBy";
import getGraphEdgeSources from "../nodeOrEdgeSourceDataHandling/getGraphEdgeSources";
import { serialize } from "../serialization";
import values from "lodash/values";
export const buildOnSaveCallback = ({ graphComponentRef, hasChangesRef, documentId, sourceDataRef, graphModelAlreadyAppliedRef, layoutAlgorithmRef, onChangeGraphModel, onSaveGraphData, completed }) => () => {
    var _a, _b, _c;
    if (documentId &&
        ((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) &&
        (sourceDataRef === null || sourceDataRef === void 0 ? void 0 : sourceDataRef.current) &&
        hasChangesRef.current) {
        const nodes = graphComponentRef.current.graph.nodes.toArray();
        const edges = graphComponentRef.current.graph.edges.toArray();
        let nodesSource = [];
        const groupsInfo = [];
        const updatesGroups = keyBy(graphModelAlreadyAppliedRef === null || graphModelAlreadyAppliedRef === void 0 ? void 0 : graphModelAlreadyAppliedRef.current.updates.Groups, "Id");
        const sourceDataGroups = ((_b = sourceDataRef.current) === null || _b === void 0 ? void 0 : _b.Groups) || {};
        forEach(nodes, n => {
            var _a, _b, _c, _d, _e;
            if ((_a = n.tag) === null || _a === void 0 ? void 0 : _a.Nodes) {
                const groupTag = n.tag;
                groupsInfo.push({
                    Id: groupTag.GroupId,
                    Name: groupTag.GroupName ||
                        ((_b = updatesGroups[groupTag.GroupId]) === null || _b === void 0 ? void 0 : _b.Name) ||
                        ((_c = sourceDataGroups[groupTag.GroupId]) === null || _c === void 0 ? void 0 : _c.Name) ||
                        "",
                    ObjectCount: groupTag.GroupObjectCount ||
                        ((_d = updatesGroups[groupTag.GroupId]) === null || _d === void 0 ? void 0 : _d.ObjectCount) ||
                        ((_e = sourceDataGroups[groupTag.GroupId]) === null || _e === void 0 ? void 0 : _e.ObjectCount) ||
                        0
                });
                nodesSource = nodesSource.concat(groupTag.Nodes);
            }
            else if (n.tag.NodeId) {
                nodesSource.push(n.tag);
            }
        });
        const edgesSource = flatMap(edges, getGraphEdgeSources);
        const prevData = (layoutAlgorithmRef === null || layoutAlgorithmRef === void 0 ? void 0 : layoutAlgorithmRef.current)
            ? { ...sourceDataRef.current, LayoutAlgorithm: layoutAlgorithmRef.current }
            : { ...sourceDataRef.current };
        const appliedUpdates = (_c = graphModelAlreadyAppliedRef.current) === null || _c === void 0 ? void 0 : _c.updates;
        if (isEmpty(nodesSource) && isEmpty(edgesSource)) {
            onChangeGraphModel === null || onChangeGraphModel === void 0 ? void 0 : onChangeGraphModel(documentId, {
                model: "",
                groups: values(prevData.Groups),
                dataGroups: prevData.DataGroups
            }, false, true);
            onSaveGraphData === null || onSaveGraphData === void 0 ? void 0 : onSaveGraphData(documentId, prevData, [], [], "", [], [], [], appliedUpdates, [], completed);
        }
        else {
            serialize({ graphComponentRef }).then(value => {
                documentId &&
                    (onChangeGraphModel === null || onChangeGraphModel === void 0 ? void 0 : onChangeGraphModel(documentId, {
                        nodes: value.Nodes,
                        edges: value.Edges,
                        dataGroups: value.DataGroups,
                        groups: groupsInfo
                    }, false, true));
                documentId &&
                    (onSaveGraphData === null || onSaveGraphData === void 0 ? void 0 : onSaveGraphData(documentId, prevData, nodesSource, edgesSource, "", value.Nodes, value.Edges, value.DataGroups, appliedUpdates, groupsInfo, completed));
            });
        }
    }
};
